module.exports = __webpack_public_path__ + "img/wlt.e57e823b.png";